import { SonarSortDirection, SonarV3SortDirection } from '@sonar-software/sonar-ts-types';

export function sort(
	direction?: SonarSortDirection, a?: string, b?: string, secondA?: string, secondB?: string
): number {
	const ascending =
        direction === undefined ||
        direction === SonarV3SortDirection.Ascending ||
        direction === 'Ascending' ||
        direction === 'ascending';

	if (a && b) {
		if (a === b && secondA && secondB) {
			return secondA.toLowerCase().localeCompare(secondB);
		}

		return ascending ?
			a.toLowerCase().localeCompare(b.toLowerCase()) :
			b.toLowerCase().localeCompare(a.toLowerCase());
	}

	if (!a && !b && secondA && secondB) {
		return secondA.toLowerCase().localeCompare(secondB.toLowerCase());
	}

	if (!a) {
		return ascending ? 1 : -1;
	}

	return ascending ? -1 : 1;
}
